import { useState, useEffect, useContext } from 'react';

import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';
import AAOEModal  from "react-modal";
	
import { getTestInfo, getAAOE, getTableForm, getLabConfig, getRequiredTests } from '../../utils/api';
import { cartActions } from '../../store/cart';
import FormHelper from '../../components/UI/FormHelper';

import MenuContext from '../../store/MenuContext';
import TestInfoClasses from './TestInfo.module.css';


import AAOE from '../../pages/AAOEfrm';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TestInfo = (props) => {
	const [PortalTitle, setPortalTitle] = useState([]);
	useEffect(() => {
        async function fetchPortalTitle() {
            const portalTitle = await getLabConfig('DTCLABEL');
            setPortalTitle(portalTitle);
        }
        fetchPortalTitle();
    }, []);
	const [LabName, setLabName] = useState([]);
	useEffect(() => {
        async function fetchLabName() {
            const labName = await getLabConfig('DTCLABNAME');
            setLabName(labName);
        }
        fetchLabName();
    }, []);
	const navigate = useNavigate();
	const location = useLocation();
	const [canonicalUrl, setCanonicalUrl] = useState('');
	useEffect(() => {
		const protocol = window.location.protocol; // "https:"
		const host = window.location.host;         // "example.com"
		const path = location.pathname;            // "/page-path"
		setCanonicalUrl(`${protocol}//${host}${path}`);
	}, [location.pathname]);
    const [testInfo, setTestInfo] = useState({});
    const cartState = useSelector(state => state.cart);
    const dispatch = useDispatch();
    const notify = () => toast("Added To Cart");
	const propstestid = props.testID;
	const tableForm = props.tableForm;
	const [aaoeData, setAaoeData] = useState([]);
		useEffect(() => {
			async function fetchAAOEData() {
				const aaoeData = await getAAOE(propstestid);
				setAaoeData(aaoeData);            
        }
        fetchAAOEData();
		}, [propstestid]);

	const [showAAOEModal, setShowAAOEModal] = useState(false);
		function closeAAOEModal () {
			setShowAAOEModal(false);
		}
	const testInCart = cartState.items.some((test) => {
        return test.ID === testInfo.ID;
    });

    useEffect(() => {
        async function fetchTestInfo() {
            const fetchedTestInfo = await getTestInfo(props.testID);
          //console.log(fetchedTestInfo);
            
            setTestInfo(fetchedTestInfo);

        }

        fetchTestInfo();
    }, [props.testID]);

	useEffect(() => {
		if (testInfo?.HTMLTitle) {
		  document.title = testInfo.HTMLTitle;
		} 
		else {
			document.title = PortalTitle;
		}
		// === Description Tag ===
		if (testInfo?.MetaDescription) {
			let descTag = document.querySelector("meta[name='description']");
			if (!descTag) {
			  descTag = document.createElement('meta');
			  descTag.setAttribute('name', 'description');
			  document.head.appendChild(descTag);
			}
			descTag.setAttribute('content', testInfo.MetaDescription);
		}
		// === Keywords Tag ===
		if (testInfo?.MetaKeywords) {
			let keywordsTag = document.querySelector("meta[name='keywords']");
			if (!keywordsTag) {
			  keywordsTag = document.createElement('meta');
			  keywordsTag.setAttribute('name', 'keywords');
			  document.head.appendChild(keywordsTag);
			}
			keywordsTag.setAttribute('content', testInfo.MetaKeywords);
		}

		// === Canonical Link Tag ===
		let canonicalTag = document.querySelector("link[rel='canonical']");
		if (!canonicalTag) {
		  canonicalTag = document.createElement('link');
		  canonicalTag.setAttribute('rel', 'canonical');
		  document.head.appendChild(canonicalTag);
		}
		canonicalTag.setAttribute('href', canonicalUrl);
		
		const script = document.createElement('script');
		script.type = 'application/ld+json';

		const schemaData = {
		  "@context": "https://schema.org/",
		  "@type": "Product",
		  "name": testInfo.TestName,
		  "description": testInfo.DTCTestDescription,
		  "sku": testInfo.TestId,
		  "brand": {
			"@type": "Organization",
			"name": LabName
		  },
		  "offers": {
			"@type": "Offer",
			"url": canonicalUrl,
			"priceCurrency": "USD",
			"price": testInfo.DTCPrice,
			"availability": "https://schema.org/InStock",
			"seller": {
			  "@type": "Organization",
			  "name": "Premier Medical Laboratory"
			}
		  }
		};

		script.text = JSON.stringify(schemaData);
		document.head.appendChild(script);

		return () => {
			document.title = PortalTitle;
			  // Cleanup to prevent duplication if the component is re-mounted
			  document.head.removeChild(script);
		};
	}, [testInfo]);

	const menuTheme = useContext(MenuContext);	

	const [requiredTests,setRequiredTests] = useState([]);
	const [conTests,setConTests] = useState([]);
	useEffect(() => {
		async function fetchRequiredTests() {
			const reqTests = await getRequiredTests();
			const tests = Array.isArray(reqTests)
			  ? reqTests
			  : typeof reqTests === "string"
			  ? [reqTests]
			  : [];
			if(tests.includes("CANNOT ORDER")) {
				setRequiredTests("CANNOT ORDER");
			}else{
				setRequiredTests(reqTests); 
				
				const conTests = await getLabConfig("DTCCONDITIONALTEST");
				const test2Array = typeof conTests === "string"
				  ? conTests.split(",")
				  : Array.isArray(conTests)
				  ? conTests
				  : [];
					// console.log(test2Array);
					// console.log(test2Array.length);
					const conTestInfo = [];
					for (let i=0; i< test2Array.length; i++) {
						conTestInfo[i] = await getTestInfo(test2Array[i]);
					};
					setConTests(conTestInfo);    
			}
		}
		fetchRequiredTests();
	}, []);
    const addToCartHandler = () => {
		if (requiredTests === "CANNOT ORDER") {
				navigate("../noServiceSysMsg", { replace: true});
		}else{
			if (requiredTests.length !== 0 ) {
				for (let i=0; i<requiredTests.length; i++) {
					const testInfoR=Object.assign({required:1},requiredTests[i]);
					const testInfoRA=Object.assign({aaoeanswers: {"none":"none"}},testInfoR);
					dispatch(cartActions.add(testInfoRA));
				}
			}
		}
		if(testInfo.AAOE === 1) {
			setShowAAOEModal(true);
		}else{
		const aaoedata=Object.assign({aaoeanswers: {}}, testInfo);
		dispatch(cartActions.add(testInfo));
        notify();
		}
		if(sessionStorage.getItem("Q3")==='Yes') {
			if (conTests.length !== 0 ) {
				for (let i=0; i<conTests.length; i++) {
					const testInfoR=Object.assign({required:0},conTests[i]);
					const testInfoRA=Object.assign({aaoeanswers: {"none":"none"}},testInfoR);
					dispatch(cartActions.add(testInfoRA));
				}
			}
		}
    };
	const handleAAOEData = (data) => {
		let data2= data['AaoeID'];
		let data3=data2.replaceAll(',','^');
		data['AaoeID']=data3;
		const aaoedata2=Object.assign({aaoeanswers: data,required:0}, testInfo);
		dispatch(cartActions.add(aaoedata2));
        notify();
		setShowAAOEModal(false);
	};
    const continueHandler = () => {
		const dataToPass = {"currentpage": props.page};
        navigate(`/availableTestwithCat`,{state:dataToPass});
    };
    const cartHandler = () => {
		const dataToPass = {"currentpage": props.page};
        navigate(`/cart`,{state:dataToPass});
    };
	const [formError,setFormError] = useState({});
	const tfHandler = (tferror) => {
		let newtfError={...tferror}
		setFormError(newtfError);
	};
    return <div className={TestInfoClasses.testInfo}>
		<div className={TestInfoClasses.testInfoContent}>
		  <FormHelper TF={tableForm} data={testInfo} onTF={tfHandler}/>
		  <AAOEModal 
			isOpen={showAAOEModal}
			onRequestClose = {closeAAOEModal}
			contentLabel = "Questions needed to be answered"
			style={{
				  content: {
					top: '200px',
					left: '50%',
					right: 'auto',
					bottom: 'auto',
					transform: 'translateX(-50%)',
					width: '60%',
					height: 'auto',
					padding: 0,
					background: 'transparent',
					border: 'none',
					boxShadow: 'none',
				  },
				  overlay: {
					backgroundColor: 'rgba(0, 0, 0, 0.5)',
				  }
				}}
			>
			<AAOE aaoes={aaoeData} onSubmit={handleAAOEData} onButtonClick={closeAAOEModal}/>

		  </AAOEModal>
	  	  <div className={TestInfoClasses.buttonArea}>  
	  		<div className={TestInfoClasses.navArea}>
			 {!testInCart && <button className={TestInfoClasses.buttonDarkBlue} onClick={addToCartHandler}>Add to Cart</button>}
			 {testInCart && <button disabled='1' className={TestInfoClasses.buttonLightBlue} >Added to Cart</button>}
				<button  className={TestInfoClasses.buttonDarkBlue} onClick={continueHandler}>
			  		Continue Shopping
			  	</button>
			  	<button  className={TestInfoClasses.buttonDarkBlue} onClick={cartHandler}>
			  		Checkout
			  	</button>			  	
			 </div>
	 	  </div> 
     </div>
     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={true} newestOnTop={false} closeOnClick rtl={false} draggable theme="light" toastStyle={{ backgroundColor: "#eeeeee", color: "#044B93" }} />
     
  </div>;
};

export default TestInfo;

